<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h2>GESTÃO ENERGÉTICA</h2>
            </v-col>

            <v-col v-for="(info, i) in (dados.informacoes || [])" :key="i" cols="6" lg="2" md="3" sm="3" xs="6">
                <CardGestaoEnergetica :titulo="info.descricao"
                    :valor="`${info.valor}${info.unidadeMedida ? ' ' + info.unidadeMedida : ''}`" />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <div class="container-filtro">
                    <label>Visualizar por:</label>

                    <!-- (item 3) v-model no radio + watch em JS -->
                    <v-radio-group v-model="filtroSelecionado" inline hide-details class="radio-group-compact">
                        <v-radio label="Dia" value="dia" />
                        <v-radio label="Semana" value="semana" />
                        <v-radio label="Mês" value="mes" />
                        <v-radio label="Ano" value="ano" />
                    </v-radio-group>
                </div>
            </v-col>

            <v-col cols="6"></v-col>

            <v-col cols="12" lg="6" md="6" sm="6" xs="12">
                <GraficoConsumoMes v-if="dados.graficoConsumoMes" :dadosGrafico="dados.graficoConsumoMes" />
            </v-col>

            <v-col cols="12" lg="6" md="6" sm="6" xs="12">
                <GraficoInformacoes v-if="dados.informacoes" :informacoes="dados.informacoes" />
            </v-col>
        </v-row>

        <v-row>
            <v-col class="linha-titulo-variaveis" cols="12">
                <div class="box-titulo-variaveis"><label>+ Variáveis</label></div>
            </v-col>

            <v-col v-for="(v, i) in (dados.variaveis || [])" :key="i" cols="12" md="4" lg="4" sm="6" xs="12">
                <div class="box-variavel">
                    <label class="label-descricao">{{ v.titulo }}</label>
                    <label class="label-valor">
                        {{ v.valor }} {{ v.unidadeMedida }}
                    </label>
                </div>
            </v-col>
        </v-row>
        <div class="rodape-plant">
            Desenvolvido por: <strong>Plant Evolution</strong> ®
        </div>
    </v-container>

</template>

<script>
    import { ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    import axios from 'axios';
    import { eventBus } from '../core/EventBus';


    import CardGestaoEnergetica from './CardGestaoEnergetica.vue';
    import GraficoConsumoMes from './GraficoConsumoMes.vue';
    import GraficoInformacoes from './GraficoInformacoes.vue';

    export default {
        components: { CardGestaoEnergetica, GraficoConsumoMes, GraficoInformacoes },

        setup() {
            const route = useRoute();
            const idEqp = ref(route.params.id);
            const dados = ref({});
            const filtro = ref('mes');
            let timerId = null;

            const fetchData = async () => {
                try {
                    const { data } = await axios.get(
                        `https://peconnect.com.br/api/equipamento/${idEqp.value}/gestaoenergetica`,
                        { params: { visualizarPor: filtro.value } }
                    );
                    dados.value = data;
                    return true;
                } catch (err) {
                    console.error('Gestão energética – erro no fetch', err);
                    return false;
                }
            };

            fetchData().then(ok => {
                if (ok) timerId = setInterval(fetchData, 5000);
            });

            watch(filtro, () => { fetchData(); });

            const stop = () => { if (timerId) clearInterval(timerId); };
            eventBus.on('vue:before-unmount', stop);
            return { dados, filtroSelecionado: filtro, stop };
        },
    };
</script>

<style scoped>
.linha-titulo-variaveis {
    padding-bottom: 5px;
}

.box-titulo-variaveis {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 22px;
    border-radius: 5px;
    background: var(--linear-branco-invertido);
    padding-left: 10px;
    width: 30%;

    label {
        font-weight: 600;
        font-size: 14px;
        line-height: 16.41px;
    }
}

.box-variavel {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    height: 60px;
    border-radius: 5px;
    background-color: var(--cinza-claro);
    border: 1px solid #6C6C6C;
}

.label-descricao {
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    vertical-align: middle;
}

.label-valor {
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    text-align: center;
    vertical-align: middle;
}

@media screen and (max-width: 640px) {
    .box-variavel {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        padding: 10px 20px 10px 20px;
        justify-content: space-between;
    }
}

.container-filtro {
    display: flex;
    align-items: center;
    padding-top: 15px;
}

.v-selection-control-group {
    grid-area: control;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 15px !important;
}

.rodape-plant {
    margin-top: 40px;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-color);
    opacity: 0.7;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>